/**
 * TAN-8655 · TAN-9802 — Punto de montaje de lo que ocurre en cada cambio de ruta (WCAG 2.4.2 y 2.4.3).
 *
 * Hoy son dos cosas, las dos de accesibilidad y las dos disparadas por la misma señal:
 *
 * - `useRouteChangeHandler` — escribe `document.title` con el título de la ruta (TAN-8655,
 *   WCAG 2.4.2 Page Titled).
 * - `useRouteFocusHandler` — devuelve el foco al landmark principal (`main`, `id="main-content"`)
 *   de la pantalla que aterriza (TAN-9802, WCAG 2.4.3 Focus Order).
 *
 * Por qué es un componente y no dos `useEffect` dentro de `Routes.js`: los dos routers —el estándar
 * y el de Edelvives, que solo difieren en las rutas, el `appName` y la regla de exactitud— montan
 * este único componente y no duplican nada. Cualquier responsabilidad futura ligada a "ha cambiado
 * la ruta" se engancha aquí, no en cada router.
 *
 * Los dos hooks son independientes a propósito: el título sale del `PageTitleContext` (la ruta ya
 * resuelta) y el foco, del `pathname` a secas — dos rutas pueden compartir `titleKey`, así que la
 * señal del título no serviría para el foco. Ver la cabecera de cada uno.
 *
 * No recibe props: cuanto necesita lo resuelve `PageTitleProvider`, que es quien recorre las
 * rutas. Debe montarse dentro de ese provider.
 *
 * Lo que NO hace: no escribe el título de las rutas que lo delegan en su página (ver `PageTitle`).
 */

import useRouteChangeHandler from 'app/router/useRouteChangeHandler';
import useRouteFocusHandler from 'app/router/useRouteFocusHandler';

function RouteChangeHandler(): null {
  useRouteChangeHandler();
  useRouteFocusHandler();

  return null;
}

export default RouteChangeHandler;
